import config from '../config'
import {
  CreditBatchFilter,
  ICreditBatchDetails,
  PaginatedCreditBatches,
} from '../pages/credit-batches-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config
const baseUrl = `${mainApi}/credit-batches`

export const getCreditBatches = (params: CreditBatchFilter) =>
  authRequest.get<MISSING_TYPE, PaginatedCreditBatches>(baseUrl, { params })

export const getCreditBatch = (id: number) =>
  authRequest.get<MISSING_TYPE, ICreditBatchDetails>(`${baseUrl}/${id}`)
